import { render, staticRenderFns } from "./AzSingleImageLoader.vue?vue&type=template&id=8ea1d2bc&"
import script from "./AzSingleImageLoader.vue?vue&type=script&lang=js&"
export * from "./AzSingleImageLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports